import React from 'react';

// Animation-free pass-through (effects disabled per user request).
const Reveal = ({ children, as: Tag = 'div', className = '', ...rest }) => {
  const {
    variant: _v,
    delay: _d,
    duration: _du,
    threshold: _t,
    rootMargin: _rm,
    ...domProps
  } = rest;
  return (
    <Tag className={className} {...domProps}>
      {children}
    </Tag>
  );
};

export default Reveal;
